import React from 'react';
import { Tooltip } from '../primitives/Tooltip/Tooltip.js';
import { Close } from '../icons/Close/Close.js';
import { useTranslation } from '../locale/useTranslation.js';

const useAllowClear = ({ allowClear, clearIconTooltip, }) => {
    const t = useTranslation();
    return React.useMemo(() => {
        if (typeof allowClear === 'undefined')
            return;
        if (allowClear === false)
            return allowClear;
        return {
            clearIcon: (React.createElement(Tooltip, Object.assign({ title: t('general.clear') }, clearIconTooltip),
                React.createElement(Close, { size: 16 }))),
        };
    }, [allowClear, clearIconTooltip, t]);
};

export { useAllowClear };
//# sourceMappingURL=useAllowClear.js.map
